export const MAXSIZEOFPIECEINADSERVER = 150.0;
